let Socket = ''
let setIntervalWesocketPush = null
let socketUrl = '';

/**
 * 建立websocket连接
 * @param {string} url ws地址
 */
export const createSocket = url => {
    console.log("createSocket");
    socketUrl = url
    Socket && Socket.close()
    if (!Socket) {
        console.log('准备建立websocket连接:', socketUrl)
        try {
            Socket = new WebSocket(socketUrl);
            console.log("WebSocket初始化完成");
        } catch (error) {
            console.error("WebSocket初始化错误：", error);
        }

        Socket.onopen = onopenWS
        Socket.onmessage = onmessageWS
        Socket.onerror = onerrorWS
        Socket.onclose = oncloseWS
    } else {
        console.log('websocket已连接')
    }
}

/**打开WS之后发送心跳 */
const onopenWS = () => {
    sendPing()
}

/**连接失败重连 */
const onerrorWS = () => {
    Socket.close()
    clearInterval(setIntervalWesocketPush)
    console.log('连接失败重连中')
    if (Socket.readyState !== 3) {
        Socket = null
        createSocket(socketUrl)
    }
}

/**WS数据接收统一处理 */
const onmessageWS = e => {
    window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
            data: e.data
        }
    }))
}


/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = message => {
    // 0 CONNECTING 1 OPEN 2 CLOSING 3 CLOSED
    var needCheck = true;
    if (Socket == null || Socket === '') {
        createSocket(socketUrl)
    } else if (Socket.readyState === 1) {
        console.log("sendWSPush", message);
        Socket.send(JSON.stringify(message));
        needCheck = false;
    } else if (Socket.readyState === 2) {
        Socket.close();
        createSocket(socketUrl);
    } else if (Socket.readyState === 3) {
        createSocket(socketUrl);
    }

    if (needCheck) {
        var waitTime = 0;
        var t1 = window.setInterval(function () {
            if (Socket.readyState === 1) {
                Socket.send(JSON.stringify(message));
                window.clearInterval(t1)
            }
            waitTime++;
            if (waitTime > 300) {
                window.clearInterval(t1)
            }
        }, 100);
    }


}

/**断开重连 */
const oncloseWS = () => {
    clearInterval(setIntervalWesocketPush)
    console.log('websocket已断开....正在尝试重连')
    if (Socket.readyState !== 2) {
        Socket = null
        createSocket(socketUrl)
    }
}
/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const sendPing = (time = 60 * 1000, ping = 'ping') => {
    clearInterval(setIntervalWesocketPush)
    Socket.send(ping)
    setIntervalWesocketPush = setInterval(() => {
        Socket.send(ping)
    }, time)
}

